import type { ButtonHTMLAttributes, ReactNode } from "react";

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  active?: boolean;
  /**
   * When set, colours the chip with the given hex — soft tint in the idle
   * state, full fill in the active one. Used on filter rows so the chip
   * matches the marker colour of whatever it filters (event type badge,
   * map marker).
   */
  color?: string;
  /** Optional soft tint (rgba) for the idle state. Falls back to --bg-secondary. */
  colorSoft?: string;
  children: ReactNode;
}

export function Chip({ active = false, color, colorSoft, children, style, ...rest }: Props) {
  const background = active
    ? color ?? "var(--brand-ink)"
    : colorSoft ?? "var(--bg-secondary)";
  const textColor = active
    ? "#fff"
    : color ?? "var(--fg1)";
  return (
    <button
      type="button"
      style={{
        border: 0,
        cursor: "pointer",
        fontFamily: "var(--font-body)",
        fontSize: 13,
        fontWeight: 500,
        padding: "8px 14px",
        borderRadius: 999,
        background,
        color: textColor,
        whiteSpace: "nowrap",
        flex: "none",
        transition: "background var(--d-fast) var(--ease-out), color var(--d-fast) var(--ease-out)",
        ...style,
      }}
      {...rest}
    >
      {children}
    </button>
  );
}

export function ChipRow({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        display: "flex",
        gap: 8,
        overflowX: "auto",
        padding: "8px 16px",
        scrollbarWidth: "none",
      }}
    >
      {children}
    </div>
  );
}
